<template>
  <section class="productHeader">
    <div class="productFoucs">
      <swiper :options="swiperOption" ref="mySwiper">
        <!-- slides -->
        <swiper-slide v-for="(item,index) in product.gallery" :key="index">
          <a
            href="javascript:;"
            class="swiper-item"
            :style="'background:url('+item+') center center no-repeat;background-size:100%'"
          ></a>
        </swiper-slide>
        <!-- Optional controls -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="price" v-if="specs[0]">
      <span>¥</span>
      {{parseInt(product.price)+parseInt(specs[0].price)+parseInt(specs[1].price)}}
    </div>
    <div class="price" v-else>
      <span>¥</span>
      {{parseInt(product.price)}}
    </div>
    <div class="name">{{product.title}}</div>
    <div class="desc"></div>
  </section>
</template>

<script>
import "swiper/dist/css/swiper.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  props: ["product", "specs"],
  data() {
    return {
      num: 1,
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          type: "fraction"
        }
      }
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  methods: {
    handleChange(value) {
      console.log(value);
    }
  }
};
</script>

<style scoped>
.productHeader {
  background: #fff;
  margin: 0 auto;
  padding: 0rem 0.13rem 0rem 0.13rem;
}
.productFoucs {
  position: relative;
}
.productFoucs .swiper-item {
  display: block;
  width: 2.52rem;
  height: 2.52rem;
  background-size: 100%;
  margin: 0rem auto 0.1rem;
}
.swiper-pagination {
  background: rgba(240, 240, 240, 1);
  width: 0.36rem;
  height: 0.2rem;
  line-height: 0.2rem;
  font-size: 0.12rem;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  border-radius:0.04rem;
  position: absolute;
  right:0;
  bottom:0.3rem;
  left:auto;
}
.productHeader .price {
font-size:0.16rem;
font-weight:bold;
color:rgba(249,65,93,1);
}
.productHeader .price span {
  font-size: 0.12rem;
}
.productHeader .name {
  padding: 0.14rem 0 0;
  color:rgba(51,51,51,1);
  font-size: 0.14rem;
}
.productHeader .desc {
  color: #888;
  padding: 0.14rem 0;
}
</style>
